import {
  incidentAction,
  busIncidentAction,
  railIncidentAction,
  operatorAssignmentAction,
} from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case incidentAction.ROLEAUTHORIZATION:
      if (
        state.disabledfields === action.payload &&
        state.hiddenfields === action.payload
      ) {
        return state;
      }
      return {
        ...state,
        disabledfields: action.payload.DisabledFields,
        hiddenfields: action.payload.HiddenFields,
      };
    case busIncidentAction.FETCHBUSINCIDENTS:
      return { ...state, busIncidents: action.payload };
    case railIncidentAction.FETCHRAILINCIDENTS:
      return { ...state, busIncidents: action.payload };
    case operatorAssignmentAction.FETCH_OPERATORS:
      return { ...state, operatorAss: action.payload };
    case operatorAssignmentAction.GET_OPERATOR_DETAIL:
      return { ...state, operatorDetail: action.payload };
    default:
      return state;
  }
};
